<template>
    <div class="qyDetails">


        <!-- 主图/VR 展示区 -->
        <div class="mediaBox">
            <iframe v-if="djobj.flag == 1" class="mediaContent" :src="djobj.url" frameborder="0"
                allow="autoplay; fullscreen"></iframe>
            <img v-else-if="djobj.url && djobj.flag != 1" class="mediaContent" :src="commenUrl + djobj.url" alt="" />
            <div v-else class="mediaPlaceholder"></div>

            <!-- 缩略图切换列表 -->
            <div class="thumbBox" v-if="urls.length > 0">
                <div v-for="(group, gi) in urls" :key="gi">
                    <div class="thumbItem" v-for="(item, vi) in group" :key="vi" @click="handleclickitem(item)"
                        :class="{ active: djobj === item }">
                        <div class="vrThumb" v-if="item.flag == 1">
                            <img src="../../../assets/images/xszgDetail/vrbj.png" alt="" />
                        </div>
                        <img v-else :src="commenUrl + item.url" alt="" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 企业信息 -->
        <div class="infoBox">
            <div class="infoHeader">
                <div class="qyName">{{ result.qymc }}</div>
                <div class="btnGroup">
                    <div class="linkBtn" v-if="result.qywz" @click="handleclickgowz(result.qywz)">前往公司网站 ></div>
                </div>
            </div>
            <div class="qyBq" v-if="result.qybq">{{ result.qybq }}</div>
            <div class="qyDesc">{{ result.qyjs }}</div>
        </div>

        <!-- 商城商品 -->
        <div class="shopBox" v-if="spList.length > 0">
            <div class="shopTitle">
                <span>商城商品</span>
                <div class="linkBtn" v-if="result.qysc" @click="handleclickgowz(result.qysc)">去商城 ></div>
            </div>
            <div class="shopList">
                <div class="shopItem" v-for="(item, index) in spList" :key="index"
                    @click="handleclickspDetail(item.splj)">
                    <div class="shopImg">
                        <img v-if="item.sptp" :src="commenUrl + item.sptp" alt="" />
                        <img v-else src="../../../assets/images/newsDefault.png" alt="" />
                    </div>
                    <div class="shopInfo">
                        <p class="shopName">{{ item.spmc }}</p>
                        <p class="shopStock" v-if="item.spkc">剩余{{ item.spkc }}</p>
                        <p class="shopPrice" v-if=" item.spjg">¥ {{ item.spjg }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const djobj = ref({});
const result = ref({});
const spList = ref([]);
const urls = ref([]);

const qyId = route.query.id;

const groupArray = (arr, size) => {
    const res = [];
    for (let i = 0; i < arr.length; i += size) {
        res.push(arr.slice(i, i + size));
    }
    return res;
};

const getQyDetail = () => {
    djobj.value = {};
    urls.value = [];
    spList.value = [];

    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_ZGQYSPLIST",
        data: { id: qyId },
    }).then((res) => {
        if (res.data.code == "000") {
            result.value = res.data.result;
            if (res.data.result.urls && res.data.result.urls.length > 0) {
                djobj.value = res.data.result.urls[0];
                urls.value = groupArray(res.data.result.urls, 5);
            }
            spList.value = res.data.result.spList.slice(0, 4);

            spList.value.forEach((item) => {
                if (item.splj) {
                    proxy.$request({
                        method: "post",
                        url: "SHOPHOME_FINDESPRODUCTINFO",
                        data: { id: item.splj.split("=")[1] },
                    }).then((res2) => {
                        if (res2.data.code == "000") {
                            item.sptp = res2.data.result.productImgs.split(",")[0];
                            item.spmc = res2.data.result.productName;
                            let unit = "";
                            JSON.parse(res2.data.result.keyAttributes).forEach((attr) => {
                                if (attr.label == "计量单位") unit = attr.value;
                            });
                            if (res2.data.result.inventoryModel == "1" && res2.data.result.productSpecs[0].dayOutput) {
                                item.spkc = res2.data.result.productSpecs[0].dayOutput + unit;
                            }
                            if (res2.data.result.inventoryModel == "0" && res2.data.result.productSpecs[0].stock) {
                                item.spkc = res2.data.result.productSpecs[0].stock + unit;
                            }
                            if (res2.data.result.productSpecs[0].salesPriceType == "1") {
                                item.spjg = "面议";
                            } else {
                                item.spjg = res2.data.result.productSpecs[0].price.toFixed(2) + "元/" + unit;
                            }
                        }
                    });
                }
            });
        }
    });
};

onMounted(() => {
    getQyDetail();
});

const handleclickitem = (obj) => {
    djobj.value = obj;
};

const handleclickgowz = (url) => {
    window.open(url);
};

const handleclickspDetail = (url) => {
    if (url) window.open(url);
};

const goBack = () => {
    router.go(-1);
};
</script>

<style lang="less" scoped>
.qyDetails {
    width: 100%;
    min-height: 100vh;
    background: url('../../../assets/images/ztbj.png') no-repeat;
    background-size: 100% 100%;
    padding: 1.2rem 0.28rem 0.28rem;
    box-sizing: border-box;

    // 顶部导航
    .topBar {
        width: 100%;
        height: 0.88rem;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 0 0.32rem;
        box-sizing: border-box;
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: 0 1px 0 #F0F0F0;

        .backBtn {
            width: 0.48rem;
            height: 0.48rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                width: 0.2rem;
                height: 0.36rem;
                object-fit: contain;
            }
        }

        .topTitle {
            flex: 1;
            text-align: center;
            font-size: 0.32rem;
            font-weight: 600;
            color: #191919;
            margin-right: 0.48rem;
        }
    }

    // 媒体展示区（主图 + 右侧缩略图）
    .mediaBox {
        width: 100%;
        background: #E8EFF9;
        position: relative;
        display: flex;
        align-items: flex-start;

        .mediaContent {
            flex: 1;
            width: 0;
            height: 5.76rem;
            object-fit: cover;
            display: block;
            margin-right: 0.2rem;
        }

        .mediaPlaceholder {
            flex: 1;
            height: 5.76rem;
            background: #E8EFF9;
            margin-right: 0.2rem;
        }

        // 右侧缩略图竖向列表
        .thumbBox {
            width: 0.98rem;
            height: 5.76rem;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            flex-shrink: 0;

            &::-webkit-scrollbar {
                display: none;
            }

            .thumbItem {
                width: 0.98rem;
                height: 0.98rem;
                flex-shrink: 0;
                cursor: pointer;
                overflow: hidden;
                background: #E8EFF9;
                margin-bottom: 0.2rem;

                &.active {
                    border: 2px solid #1663FF;
                    box-sizing: border-box;
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                .vrThumb {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #E8EFF9;

                    img {
                        width: 0.5rem;
                        height: 0.38rem;
                        object-fit: contain;
                    }
                }
            }
        }
    }

    // 企业基本信息
    .infoBox {
        background: linear-gradient( 0deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 100%);
        padding: 0.4rem 0.32rem 0.3rem;
        margin: 0.2rem 0 ;

        .infoHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.12rem;

            .qyName {
                flex: 1;
                font-size: 0.4rem;
                font-weight: 600;
                color: #191919;
                line-height: 1.4;
            }

            .btnGroup {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 0.12rem;
                margin-left: 0.2rem;

                .linkBtn {
                    padding: 0.1rem 0.2rem;
                    background: #DFEAFF;
                    border-radius: 0.06rem;
                    font-size: 0.22rem;
                    font-weight: 600;
                    color: #1663FF;
                    cursor: pointer;
                    white-space: nowrap;
                }
            }
        }

        .qyBq {
            font-size: 0.26rem;
            color: #1663FF;
            margin-bottom: 0.24rem;
            line-height: 1.4;
        }

        .qyDesc {
            font-size: 0.26rem;
            color: #748199;
            line-height: 1.8;
        }
    }

    // 商城商品
    .shopBox {
        background: #fff;
        padding: 0.32rem;

        .shopTitle {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.24rem;

            span {
                font-size: 0.32rem;
                font-weight: 600;
                color: #191919;
            }

            .linkBtn {
                padding: 0.08rem 0.18rem;
                background: #DFEAFF;
                border-radius: 0.06rem;
                font-size: 0.22rem;
                font-weight: 600;
                color: #1663FF;
                cursor: pointer;
                white-space: nowrap;
            }
        }

        .shopList {
            display: flex;
            flex-direction: column;
            gap: 0;

            .shopItem {
                display: flex;
                align-items: center;
                padding: 0.24rem 0;
                border-bottom: 1px solid #F0F0F0;
                cursor: pointer;

                &:last-child {
                    border-bottom: none;
                }

                .shopImg {
                    width: 1.44rem;
                    height: 1.44rem;
                    border-radius: 0.08rem;
                    background: #E8EFF9;
                    flex-shrink: 0;
                    overflow: hidden;
                    margin-right: 0.24rem;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }
                }

                .shopInfo {
                    flex: 1;
                    width: 0;
                    height:1.44rem;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .shopName {
                        height:0.4rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #191919;
                        line-height: 0.4rem;
                        margin-bottom: 0.1rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .shopStock {
                        height:0.34rem;
                        line-height: 0.3rem;
                        font-size: 0.24rem;
                        color: #313A4B;
                        margin-bottom: 0.32rem;
                    }

                    .shopPrice {
                        height:0.4rem;
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        font-weight: 600;
                        color: #FF2D2D;
                    }
                }
            }
        }
    }
}
</style>
